import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { WorldMapProvider } from "../../contexts/WorldMapContext";
import { factoryActions } from "../../util/store/factory/reducer";
import { locationActions } from "../../util/store/location/reducer";
import { siteActions } from "../../util/store/site/reducer";
import Control from "./Control";
import Map from "./Map";
import { RouteUpgradeProvider } from "./RouteUpgradeContext";

interface IProps {
}

const RouteUpgradePage: React.FC<IProps> = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(factoryActions.getsByAdmin())
        dispatch(locationActions.getPois())
        dispatch(siteActions.gets())
    }, [dispatch]);

    return <div className="m-header relative bgPage">
        <RouteUpgradeProvider>
            <WorldMapProvider hideLabel={false}>
                <Map />
                <Control />
            </WorldMapProvider>
        </RouteUpgradeProvider>
    </div>;
};

export default RouteUpgradePage;
